"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuth2RequestType = exports.JWTTokenEncoding = exports.JWTAlgorithm = exports.AuthorizationType = exports.AuthenticationMethod = void 0;
var AuthenticationMethod;
(function (AuthenticationMethod) {
    AuthenticationMethod[AuthenticationMethod["WEBHOOKS"] = 0] = "WEBHOOKS";
    AuthenticationMethod[AuthenticationMethod["API"] = 1] = "API";
})(AuthenticationMethod || (exports.AuthenticationMethod = AuthenticationMethod = {}));
var AuthorizationType;
(function (AuthorizationType) {
    AuthorizationType[AuthorizationType["JWT_TOKEN"] = 0] = "JWT_TOKEN";
    AuthorizationType[AuthorizationType["OAUTH2"] = 1] = "OAUTH2";
    AuthorizationType[AuthorizationType["STATIC_HEADER"] = 2] = "STATIC_HEADER";
})(AuthorizationType || (exports.AuthorizationType = AuthorizationType = {}));
var JWTAlgorithm;
(function (JWTAlgorithm) {
    JWTAlgorithm["HS256"] = "HS256";
    JWTAlgorithm["HS512"] = "HS512";
})(JWTAlgorithm || (exports.JWTAlgorithm = JWTAlgorithm = {}));
var JWTTokenEncoding;
(function (JWTTokenEncoding) {
    JWTTokenEncoding[JWTTokenEncoding["BASE64"] = 0] = "BASE64";
    JWTTokenEncoding[JWTTokenEncoding["NONE"] = 1] = "NONE";
})(JWTTokenEncoding || (exports.JWTTokenEncoding = JWTTokenEncoding = {}));
var OAuth2RequestType;
(function (OAuth2RequestType) {
    OAuth2RequestType[OAuth2RequestType["FORM"] = 0] = "FORM";
    OAuth2RequestType[OAuth2RequestType["JSON"] = 1] = "JSON";
    OAuth2RequestType[OAuth2RequestType["QUERY_STRING"] = 2] = "QUERY_STRING";
})(OAuth2RequestType || (exports.OAuth2RequestType = OAuth2RequestType = {}));
//# sourceMappingURL=webhook_authentication_configuration.js.map